import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { serviceAreas } from "../../data/services";
import { SectionLabel } from "../SectionLabel";
type WhatWeDoProps = {
  label?: string;
  heading?: string;
  showProcess?: boolean;
};
export function WhatWeDo({
  label = "What we do",
  heading = "Two specialties, held to the same standard.",
  showProcess = true
}: WhatWeDoProps) {
  const [payroll, hrtech, process] = serviceAreas;
  return <section aria-labelledby="what-we-do" className="shell py-24 md:py-32" data-id="element-185" data-mp="3mfgx2u1sijzs">
      <div className="grid grid-cols-12 gap-x-6 gap-y-8 pb-14" data-id="element-186" data-mp="38f685wk1jfh9">
        <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-187" data-mp="38emrej64mx4t">
          <SectionLabel data-id="element-188" data-mp="3cfzvanpnsq93">{label}</SectionLabel>
        </div>
        <h2 id="what-we-do" className="col-span-12 font-display text-[clamp(2.25rem,4.6vw,4rem)] leading-[1.05] text-navy lg:col-span-9" data-id="element-189" data-mp="3cim22l4q71q9">
          {heading}
        </h2>
      </div>

      <div className="grid grid-cols-1 border-t border-navy md:grid-cols-2" data-id="element-190" data-mp="3kavwa3as6jo7">
        {[payroll, hrtech].map((s, i) => <article key={s.id} aria-labelledby={`${s.id}-home`} className={`flex flex-col py-12 md:py-16 ${i === 1 ? "border-t border-stone md:border-l md:border-t-0 md:pl-12 lg:pl-16" : "md:pr-12 lg:pr-16"}`} data-id="element-191" data-mp="3fccac2w6t7vu" data-mpi={i}>
            <span className="font-display text-xl tabular-nums text-oxblood" data-id="element-192" data-mp="743xijbwi019">{s.number}</span>
            <h3 id={`${s.id}-home`} className="mt-4 font-display text-[clamp(2.75rem,5vw,4.5rem)] leading-[1] tracking-[-0.01em] text-navy" data-id="element-193" data-mp="25k828y3m645">
              <span className="block" data-id="element-194" data-mp="gvzsvmmlrc1s">{s.titleLines[0]}</span>
              <span className="block" data-id="element-195" data-mp="bwetxc7fn3p2">{s.titleLines[1]}</span>
            </h3>
            <p className="mt-6 font-display text-2xl italic text-oxblood" data-id="element-196" data-mp="pu3iov4meuze">{s.tagline}</p>
            <p className="mt-5 max-w-md text-lg leading-relaxed text-charcoal/80" data-id="element-197" data-mp="kwa9dt80tkuw">{s.sentence}</p>
            <ul className="mt-10 border-b border-stone" data-id="element-198" data-mp="3eo9yybhxw1ch">
              {s.highlights.slice(0, 5).map(h => <li key={h} className="border-t border-stone py-3 text-[15px] text-charcoal" data-id="element-199" data-mp="3jm1o4xr799cz">
                  {h}
                </li>)}
            </ul>
            <div className="mt-auto pt-10" data-id="element-200" data-mp="3sf535ahhtu9q">
              <Link to={s.path} className="link-rule" data-id="element-201" data-mp="3sfy9wbggcjrv">
                Explore {s.title}
              </Link>
            </div>
          </article>)}
      </div>

      {showProcess && <Link to={process.path} className="group grid grid-cols-12 items-baseline gap-x-6 gap-y-3 border-y border-stone py-10" data-id="element-202" data-mp="66vl5z9wsstv">
        <span className="col-span-2 font-display text-xl tabular-nums text-oxblood md:col-span-1" data-id="element-203" data-mp="b56um8wal1bk">{process.number}</span>
        <span className="col-span-10 font-display text-3xl text-navy transition-colors duration-150 group-hover:text-oxblood md:col-span-4 md:text-4xl" data-id="element-204" data-mp="2cywh3a03vhk5">
          {process.title}
        </span>
        <span className="col-span-10 col-start-3 leading-relaxed text-charcoal/75 md:col-span-6 md:col-start-auto" data-id="element-205" data-mp="29g75mmjzyqia">
          Around both: {process.tagline.charAt(0).toLowerCase() + process.tagline.slice(1)}
        </span>
        <ArrowRightIcon aria-hidden strokeWidth={1.25} className="hidden h-5 w-5 justify-self-end text-oxblood transition-transform duration-200 ease-ledger group-hover:translate-x-1 md:col-span-1 md:block" data-id="element-206" data-mp="1zrp7ye70kziv" />
      </Link>}
    </section>;
}